import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Pages/Home';

import About1 from './Pages/About1';

import PersonalData from './Pages/PersonalData';
import DataProtection from './Pages/DataProtection';

import ModuleProyects from './Pages/ModuleProyects';

import Presentation from './Pages/Presentation';

import FinzanceModule from './Pages/FinzanceModule';
import WorkModule from './Pages/WorkModule';
import ReportsModule from './Pages/ReportsModule';
import AdminModule from './Pages/AdminModule';
import Services1 from './Pages/Services1';
import ServiceDetailAdmin from './Pages/ServiceDetailAdmin';
import ServiceDetailProyects from './Pages/ServiceDetailProyects';
import ServiceDetailObra from './Pages/ServiceDetailObra';
import ServiceDetailReports from './Pages/ServiceDetailReports';
import ServiceDetailFinance from './Pages/ServiceDetailFinance';
import ServiceDetailPresupuestos from './Pages/ServiceDetailPresupuestos';

import DeclaracionPrivacidad from './Pages/DeclaracionPrivacidad';
import TerminosCondiciones from './Pages/TerminosCondiciones';
import AvisoLegal from './Pages/AvisoLegal';
import Accesibilidad from './Pages/Accesibilidad';
import PoliticaCookies from './Pages/PoliticaCookies';
import PoliticaRedesSociales from './Pages/PoliticaRedesSociales';
import Copyright from './Pages/Copyright';



import Team1 from './Pages/Team1';
import Team2 from './Pages/Team2';
import TeamDetail from './Pages/TeamDetail';

import FontIcons from './Pages/FontIcons';
import Error from './Pages/Error';

import ProjectGrid3 from './Pages/ProjectGrid3';
import ProjectGridNoGap3 from './Pages/ProjectGridNoGap3';
import ProjectGrid4 from './Pages/ProjectGrid4';
import ProjectGridNoGap4 from './Pages/ProjectGridNoGap4';
import ProjectGrid5 from './Pages/ProjectGrid5';
import ProjectGridNoGap5 from './Pages/ProjectGridNoGap5';

import ProjectMasonary3 from './Pages/ProjectMasonary3';
import ProjectMasonaryNoGap3 from './Pages/ProjectMasonaryNoGap3';
import ProjectMasonary4 from './Pages/ProjectMasonary4';
import ProjectMasonaryNoGap4 from './Pages/ProjectMasonaryNoGap4';
import ProjectMasonary5 from './Pages/ProjectMasonary5';
import ProjectMasonaryNoGap5 from './Pages/ProjectMasonaryNoGap5';

import ProjectCorousel from './Pages/ProjectCorousel';
import ProjectDetail1 from './Pages/ProjectDetail1';
import ProjectDetail2 from './Pages/ProjectDetail2';

import BlogGrid from './Pages/BlogGrid';
import BlogListing from './Pages/BlogListing';
import BlogMasonary from './Pages/BlogMasonary';
import BlogSingle from './Pages/BlogSingle';
import PostRightSidebar from './Pages/PostRightSidebar';

import ShopGrid from './Pages/ShopGrid';
import ShopList from './Pages/ShopList';
import ShopDetail from './Pages/ShopDetail';
import ShopAccount from './Pages/ShopAccount';
import ShopCart from './Pages/ShopCart';
import ShopCheckout from './Pages/ShopCheckout';

import Faq from './Pages/Faq';
import ContactUs from './Pages/ContactUs';
import Pricing from './Pages/Pricing';
import PricingCheckout from './Pages/PricingCheckout';
import ScrollToTop from './Common/ScrollToTop';

class Components extends React.Component {
    render() {
        return (
            <BrowserRouter basename="/">
                <ScrollToTop />
                <div className="page-wraper">
                <Routes>
                        <Route path='/' element={<Home />} />
                        <Route path='/acerca-de' element={<About1 />} />
                        <Route path='/personal-data' element={<PersonalData />} />
                        <Route path='/data-protection' element={<DataProtection />} />
                        <Route path='/presentacion' element={<Presentation />} />
                        <Route path='/modulo-finanzas' element={<FinzanceModule />} />
                        <Route path='/modulo-obra' element={<WorkModule />} />
                        <Route path='/modulo-reportes' element={<ReportsModule />} />
                        <Route path='/modulo-admin' element={<AdminModule />} />
                        <Route path='/services' element={<Services1 />} />
                        <Route path='/modulo-proyectos' element={<ModuleProyects />} />
                        <Route path='/services-detail-administration' element={<ServiceDetailAdmin />} />
                        <Route path='/services-detail-proyectos' element={<ServiceDetailProyects />} />
                        <Route path='/services-detail-obra' element={<ServiceDetailObra />} />
                        <Route path='/services-detail-reportes' element={<ServiceDetailReports />} />
                        <Route path='/services-detail-finanzas' element={<ServiceDetailFinance />} />
                        <Route path='/services-detail-presupuestos' element={<ServiceDetailPresupuestos />} />
                        
                        <Route path='/declaracion-de-privacidad' element={<DeclaracionPrivacidad />} />
                        <Route path='/terminos-y-condiciones' element={<TerminosCondiciones />} />
                        <Route path='/aviso-legal' element={<AvisoLegal />} />
                        <Route path='/accesibilidad' element={<Accesibilidad />} />
                        <Route path='/politica-de-cookies' element={<PoliticaCookies />} />
                        <Route path='/politica-de-redes-sociales' element={<PoliticaRedesSociales />} />
                        <Route path='/derechos-autor' element={<Copyright />} />


                        <Route path='/team-1' element={<Team1 />} />
                        <Route path='/team-2' element={<Team2 />} />
                        <Route path='/team-single' element={<TeamDetail />} />

                        <Route path='/icon-font' element={<FontIcons />} />
                        <Route path='/error-404' element={<Error />} />

                        <Route path='/project-grid-3-columns' element={<ProjectGrid3 />} />
                        <Route path='/project-grid-3-columns-no-gap' element={<ProjectGridNoGap3 />} />
                        <Route path='/project-grid-4-columns' element={<ProjectGrid4 />} />
                        <Route path='/project-grid-4-columns-no-gap' element={<ProjectGridNoGap4 />} />
                        <Route path='/project-grid-5-columns' element={<ProjectGrid5 />} />
                        <Route path='/project-grid-5-columns-no-gap' element={<ProjectGridNoGap5 />} />

                        <Route path='/project-masonry-3-columns' element={<ProjectMasonary3 />} />
                        <Route path='/project-masonry-3-columns-no-gap' element={<ProjectMasonaryNoGap3 />} />
                        <Route path='/project-masonry-4-columns' element={<ProjectMasonary4 />} />
                        <Route path='/project-masonry-4-columns-no-gap' element={<ProjectMasonaryNoGap4 />} />
                        <Route path='/project-masonry-5-columns' element={<ProjectMasonary5 />} />
                        <Route path='/project-masonry-5-columns-no-gap' element={<ProjectMasonaryNoGap5 />} />

                        <Route path='/project-carousel' element={<ProjectCorousel />} />
                        <Route path='/project-detail1' element={<ProjectDetail1 />} />
                        <Route path='/project-detail2' element={<ProjectDetail2 />} />

                        <Route path='/blog-grid' element={<BlogGrid />} />
                        <Route path='/blog-listing' element={<BlogListing />} />
                        <Route path='/blog-masonry' element={<BlogMasonary />} />
                        <Route path='/blog-single' element={<BlogSingle />} />
                        <Route path='/post-right-sidebar' element={<PostRightSidebar />} />

                        <Route path='/shop-grid' element={<ShopGrid />} />
                        <Route path='/shop-list' element={<ShopList />} />
                        <Route path='/shop-detail' element={<ShopDetail />} />
                        <Route path='/shop-account' element={<ShopAccount />} />
                        <Route path='/shop-cart' element={<ShopCart />} />
                        <Route path='/shop-checkout' element={<ShopCheckout />} />

                        {/* <Route path='/faq' element={<Faq />} /> */}
                        <Route path='/pricing' element={<Pricing />} />
                        <Route path='/checkout' element={<PricingCheckout />} />
                        <Route path='/contact-us' element={<ContactUs />} />

                        {/* Redirect any undefined routes to /dont-exists */}
                        <Route path="*" element={<Error />} />
                    </Routes>
                </div>
            </BrowserRouter>
        );
    };
};


export default Components;